window.addEventListener("DOMContentLoaded", () => {
  const targetSelector = "#app-embed-container-653386";

  function applyAdjustments(root) {
    const style = document.createElement("style");
    style.textContent = `
            :host {
                --nopg-dark: rgb(0, 71, 87);
                --nopg-light: #f8efdd;
            }

            #app-embed button[class*='_teaserContainer'] {
                aspect-ratio: 1 / 1;
                background-color: var(--nopg-light);
                border-radius: calc(infinity * 1px);
                padding: 1.6rem;
                transition: background-color cubic-bezier(0.4, 0, 0.2, 1) 150ms;
            }

            #app-embed button[class*='_teaserContainer'] h3[class*='_teaserHeading'] {
                transition: color cubic-bezier(0.4, 0, 0.2, 1) 150ms;
            }

            #app-embed button[class*='_teaserContainer']:hover {
                background-color: var(--nopg-dark);
            }

            #app-embed button[class*='_teaserContainer']:hover h3[class*='_teaserHeading'] {
                color: var(--nopg-light);
            }

            #app-embed span[class*='_formCloseButton'] {
                position: absolute;
                top: 0;
                right: -0.25rem;
                background-color: white;
                border-radius: 100%;
                aspect-ratio: 1 / 1;
                width: 2rem;
                height: 2rem;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: background-color cubic-bezier(0.4, 0, 0.2, 1) 150ms;
            }

            #app-embed span[class*='_formCloseButton'] > svg {
                fill: var(--nopg-dark);
                fill-opacity: 1;
                transition: fill cubic-bezier(0.4, 0, 0.2, 1) 150ms;
            }

            #app-embed span[class*='_formCloseButton']:hover {
                background-color: var(--nopg-dark);
            }

            #app-embed span[class*='_formCloseButton']:hover > svg {
                fill: white;
            }
        `;

    root.appendChild(style);
    // console.log("Welcome form adjustments applied");
  }

  function watchForShadowRoot(formEl) {
    // If shadow root is already there, apply immediately
    if (formEl.shadowRoot) {
      applyAdjustments(formEl.shadowRoot);
      return;
    }

    // Otherwise, observe until shadowRoot appears
    const shadowObserver = new MutationObserver(() => {
      if (formEl.shadowRoot) {
        applyAdjustments(formEl.shadowRoot);
        shadowObserver.disconnect();
      }
    });

    shadowObserver.observe(formEl, { childList: true });
    //   console.log("Waiting for shadow root to be attached...");
  }

  // Watch for the form element itself
  const formObserver = new MutationObserver(() => {
    const formEl = document.querySelector(targetSelector);
    if (formEl) {
      // console.log("Form element found");
      watchForShadowRoot(formEl);
      formObserver.disconnect(); // stop watching once we find it
    }
  });

  formObserver.observe(document.body, { childList: true, subtree: true });
  // console.log("Waiting for form element...");
});
